import { FormGroup, Input, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

export const DataBasicForm = ({ control, errors }) => {
  const { getData } = useDataFetch();
  const { data: dataCategories, isLoading: loadingCategories } = getData(
    ["categories"],
    "/product/all/categories"
  );

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 18px", fontSize: 16, fontWeight: 700 }}>Datos básicos</h3>

      <FormGroup>
        <Label>Título <span style={{ color: "#DC2626" }}>*</span></Label>
        <Controller
          name="title"
          control={control}
          rules={{ required: "El título es obligatorio" }}
          render={({ field }) => <Input type="text" invalid={!!errors.title} {...field} />}
        />
        {errors.title && <div style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>{errors.title.message}</div>}
      </FormGroup>

      <FormGroup>
        <Label>Categoría <span style={{ color: "#DC2626" }}>*</span></Label>
        <Controller
          name="category"
          control={control}
          rules={{ required: "La categoría es obligatoria" }}
          render={({ field }) => (
            <Input type="select" invalid={!!errors.category} {...field}>
              <option value="">Selecciona una categoría</option>
              {loadingCategories ? (
                <option>Cargando...</option>
              ) : (
                dataCategories?.data?.categories.map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))
              )}
            </Input>
          )}
        />
        {errors.category && <div style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>{errors.category.message}</div>}
      </FormGroup>

      <FormGroup>
        <Label>Descripción corta <span style={{ color: "#DC2626" }}>*</span></Label>
        <Controller
          name="shortDescription"
          control={control}
          rules={{ required: "La descripción corta es obligatoria" }}
          render={({ field }) => <Input type="textarea" rows={2} invalid={!!errors.shortDescription} {...field} />}
        />
        {errors.shortDescription && <div style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>{errors.shortDescription.message}</div>}
      </FormGroup>

      <FormGroup className="mb-0">
        <Label>Descripción larga <span style={{ color: "#DC2626" }}>*</span></Label>
        <Controller
          name="longDescription"
          control={control}
          rules={{ required: "La descripción larga es obligatoria" }}
          render={({ field }) => <Input type="textarea" rows={4} invalid={!!errors.longDescription} {...field} />}
        />
        {errors.longDescription && <div style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>{errors.longDescription.message}</div>}
      </FormGroup>
    </div>
  );
};
